import axios from "axios";
import { authenticateService } from "./CommonService";

export const editRomResult = async (data) => {
  const token = await authenticateService();
  if (token.jwt) {
    try {
      const response = await axios.post(
        "/api/v1/endUser/admin/dashboard/assessmentReportStats/edit/RomResults",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token.jwt}`,
          },
        }
      );
      return response;
    } catch (error) {
      return error;
    }
  }
};

export const editHoldResult = async (data) => {
  const token = await authenticateService();
  if (token.jwt) {
    try {
      const response = await axios.post(
        "/api/v1/endUser/admin/dashboard/assessmentReportStats/edit/BalanceResults",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token.jwt}`,
          },
        }
      );
      return response;
    } catch (error) {
      return error;
    }
  }
};


export const editRepResult = async (data) => {
  const token = await authenticateService();
  if (token.jwt) {
    try {
      const response = await axios.post(
        `/api/v1/endUser/admin/dashboard/assessmentReportStats/edit/RepResults`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token.jwt}`,
          },
        }
      );
      return response;
    } catch (error) {
      return error;
    }

  }

}

export const getUserMovementVideo = async (userId, sessionId, exerciseId) => {
  const token = await authenticateService();
  if (token.jwt) {
    try {
      const response = await axios.get(
        `/api/v1/endUser/admin/dashboard/assessmentReportStats/getUserMovementVideo?userId=${userId}&encryptedSessionId=${sessionId}&exerciseId=${exerciseId}&movement=movement1.mp4`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token.jwt}`,
          },
        }
      );
      return response;
    } catch (error) {
      return error;
    }
  }
};
